module.exports = {"index-login-title":"Log in to My Arriva Flow","info-not-registered":"To register for Arriva Flow,","info-activation-link":"first activate Arriva Flow in My Arriva","invalid-customer-type-notification-first":"Arriva Flow has not been activated for this account. Please \"log out\" and activate Arriva Flow for this account, then log in again.","invalid-customer-type-notification-second":"If your Arriva Flow account has not yet been activated, click \"Activate your account in My Arriva\" to go to the Arriva Flow activation page."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/abt-payment.json
// module id = 3PsL
// module chunks = 1